// extracted by mini-css-extract-plugin
module.exports = {"container":"Profile_container__sYn8S","avatar":"Profile_avatar__3XmQt","cardHeader":"Profile_cardHeader__2scPH"};